import TableCell from "@mui/material/TableCell";
import { memo, FC } from "react";
import { LinkButton } from "../../../atoms/linkButton";

type Props = {
  url: string;
};

export const MembershipTypeActionCell: FC<Props> = memo(({ url }) => {
  return (
    <TableCell
      variant="body"
      padding={"normal"}
      sx={{
        textAlign: "center",
      }}
    >
      {/* アクションボタン */}
      <LinkButton url={url} text={"献立一覧へ"} />
    </TableCell>
  );
});
